const spacingUnit = 16;

export default {
  spacingUnit,
  xsmall: `${spacingUnit / 4}px`,
  small: `${spacingUnit / 2}px`,
  normal: `${spacingUnit}px`,
  medium: `${spacingUnit * 1.5}px`,
  large: `${spacingUnit * 2}px`,
  xlarge: `${spacingUnit * 2.5}px`,
  xxlarge: `${spacingUnit * 3}px`,
};
